import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getTranslate } from 'react-localize-redux'
import history from '../../history'
import { getSubscriptionDetails } from '../../redux/actions/dashboardActions'

import SubscriptionDetail from '../../components/subscription'
import Loading from '../../components/loading'
import NoData from '../../components/nodata'

class SubscriptionPage extends Component {
  componentWillMount() {
    const { subscriptionId } = this.props.match.params
    if (subscriptionId) {
      this.props.getSubscriptionDetails(parseInt(subscriptionId))
    }
  }

  handleBack = () => {
    history.push('/dashboard')
  }

  render() {
    const { translate, dashboard, loading } = this.props
    const { subscriptionDetails } = dashboard

    if (loading) {
      return <Loading />
    }

    if (!subscriptionDetails) {
      return <NoData translate={translate} />
    }

    return (
      <SubscriptionDetail
        translate={translate}
        subscription={subscriptionDetails}
        onBack={this.handleBack}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  dashboard: state.dashboardReducer,
  translate: getTranslate(state.localeReducer),
  ...state
})

const mapDispatchToProps = {
  getSubscriptionDetails
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(SubscriptionPage)
